import { all, takeEvery, put } from 'redux-saga/effects';
import { scheduleDraftPublishSuccess } from '@wix/da-submit-shared/pkg/redux/actions';
import { addNotification } from '@wix/da-shared-react/pkg/Notifications/redux/actionCreators';
import { refreshTable } from '../../actions/studio';
import { NotificationType } from '../../types/notifications';

function* handleScheduleDraftPublishSuccess({
  payload: { deviation, scheduleTs },
}: ReturnType<typeof scheduleDraftPublishSuccess>) {
  yield put(refreshTable({ preservePage: true }));

  // don't show notification when schedule is being turned off
  if (scheduleTs > 0) {
    yield put(
      addNotification(NotificationType.DEVIATION_SCHEDULE, {
        deviation,
        scheduleTs,
      })
    );
  }
}

export default function* scheduleSaga() {
  yield all([
    takeEvery(scheduleDraftPublishSuccess, handleScheduleDraftPublishSuccess),
  ]);
}
